import { render, staticRenderFns } from "./TableLicenciaAlcoholes.vue?vue&type=template&id=30561bb4&"
import script from "./TableLicenciaAlcoholes.vue?vue&type=script&lang=js&"
export * from "./TableLicenciaAlcoholes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports